
function getTimeString(date, now) {
    const diffMs = date - now;
    if (diffMs < 0) return '(already passed)';

    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    // 按日历计算天、月、年
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const targetStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const diffDays = Math.round((targetStart - todayStart) / (1000 * 60 * 60 * 24));

    let diffYears = date.getFullYear() - now.getFullYear();
    let diffMonths = diffYears * 12 + (date.getMonth() - now.getMonth());
    // 如果目标日期的日 < 当前日，月份还没满一个月
    if (date.getDate() < now.getDate()) {
        diffMonths--;
    }
    diffYears = Math.floor(diffMonths / 12);

    if (diffMinutes < 60) {
        if (diffMinutes <= 0) return '(less than a minute)';
        return `(in ${diffMinutes} minute${diffMinutes > 1 ? 's' : ''})`;
    } else if (diffHours < 24) {
        return `(in ${diffHours} hour${diffHours > 1 ? 's' : ''})`;
    } else if (diffDays < 30) {
        return `(in ${diffDays} day${diffDays > 1 ? 's' : ''})`;
    } else if (diffMonths > 0 && diffYears <= 0) {
        return `(in ${diffMonths} month${diffMonths > 1 ? 's' : ''})`;
    } else if (diffYears > 0) {
        return `(in ${diffYears} year${diffYears > 1 ? 's' : ''})`;
    } else {
        return `(in ${diffDays} day${diffDays > 1 ? 's' : ''})`;
    }
}

export function formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const options = {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
        hour: 'numeric', minute: 'numeric', hour12: true
    };
    const formattedDate = date.toLocaleString('en-US', options);
    const timeString = getTimeString(date, new Date());
    return `${formattedDate}\n${timeString}`;
}

export function formatTimestamp2(timestamp) {
    const date = new Date(timestamp);
    const options = {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
        hour: 'numeric', minute: 'numeric', hour12: true
    };
    const formattedDate = date.toLocaleString('en-US', options);
    const timeString = getTimeString(date, new Date());
    return { formattedDate, timeString };
}
